/**
 * KAN-826: table of the page "Организации": name (link to the company card),
 * city, ИНН, phones, number of contacts. Scrolls sideways on narrow screens.
 */
import { Link } from 'react-router-dom';
import type { ClientCompany } from '@/types/clientCompany';

interface ClientCompaniesTableProps {
  rows: ClientCompany[];
}

const TH = 'whitespace-nowrap px-3 py-2 text-left text-xs font-medium uppercase tracking-wide text-gray-500';
const TD = 'px-3 py-2 align-top';

export function ClientCompaniesTable({ rows }: ClientCompaniesTableProps) {
  return (
    <div className="overflow-x-auto rounded-lg border border-gray-200 bg-white">
      <table className="min-w-full text-sm">
        <thead className="border-b border-gray-200 bg-gray-50">
          <tr>
            <th scope="col" className={TH}>Название</th>
            <th scope="col" className={TH}>Город</th>
            <th scope="col" className={TH}>ИНН</th>
            <th scope="col" className={TH}>Телефоны</th>
            <th scope="col" className={`${TH} text-right`}>Контакты</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.id} data-testid="client-company-row" className="border-b border-gray-100 last:border-0">
              <td className={`${TD} min-w-[180px]`}>
                <Link to={`/companies/${row.id}`} className="font-medium text-blue-700 hover:underline">
                  {row.name || 'Без названия'}
                </Link>
              </td>
              <td className={TD}>{row.city}</td>
              <td className={`${TD} whitespace-nowrap`}>{row.inn}</td>
              <td className={`${TD} min-w-[160px] text-gray-700`}>{row.phones.join(', ')}</td>
              <td className={`${TD} text-right tabular-nums`}>{row.contacts_count}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
